var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDudeRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0503C",
    d: "M0 0h73L36.5 36.5V73H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M42.583 62.57H30.416v-6.952h12.167z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M57.327 47.825L42.579 62.573l-4.915-4.916L52.41 42.91zM20.56 42.907l14.746 14.747-4.915 4.916-14.748-14.747zM0 10.815h32.444v13.519H0zM40.556 10.815H73v13.519H40.556z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M62.185 13.519h8.111v8.111h-8.111zM21.63 13.519h8.111v8.111H21.63z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDudeRed);
export default __webpack_public_path__ + "static/media/dude-red.4d0cce2f.svg";
export { ForwardRef as ReactComponent };